import React from 'react';
import bubblesvg from "../../../images/Bubble.svg";
import {BubbleFloatStyled} from "../../../styled/BubbleFloat";
import {useTheme} from "../Theme/ThemeContext";
import Blob from "../Blob/Blob";
import bubblebg from "../../../images/bubblebg-auth.jpg"


const BubbleFloat = ({img,type}) => {
    const {themeName} = useTheme();

    return (
        <BubbleFloatStyled theme={themeName} type={type}>
            {!type && <img src={img || bubblesvg} alt="bubble asset floating"/>}
            {type === 'droplets' && <img src={img} alt="bubble asset floating"/>}
            {/*<Blob bgImage={bubblebg} alt="bubble asset floating" />*/}
        </BubbleFloatStyled>
    );

}

export default BubbleFloat